class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.closeTimeout = null;

    this.onMouseEnterHandler = this.onMouseEnter.bind(this);
    this.onMouseLeaveHandler = this.onMouseLeave.bind(this);
    this.onSummaryClickHandler = this.onSummaryClick.bind(this);

    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnterHandler);
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeaveHandler);
    this.summary.addEventListener('click', this.onSummaryClickHandler);
  }

  isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  onSummaryClick(event) {
    if (this.isDesktop()) {
      event.preventDefault();
    }
  }

  onMouseEnter() {
    if (!this.isDesktop()) return;

    clearTimeout(this.closeTimeout);
    this.closeSiblingMenus();
    this.open();
  }

  onMouseLeave() {
    if (!this.isDesktop()) return;

    this.closeTimeout = setTimeout(() => {
      this.close();
    }, 150);
  }

  closeSiblingMenus() {
    const nav = this.closest('.header__inline-menu');
    if (!nav) return;

    nav.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });
  }

  open() {
    clearTimeout(this.closeAnimationTimeout);
    this.mainDetailsToggle.classList.remove('menu-closing');

    if (this.mainDetailsToggle.hasAttribute('open')) return;

    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
  }

  close() {
    if (!this.isDesktop() || !this.mainDetailsToggle.hasAttribute('open')) {
      super.close();
      return;
    }

    clearTimeout(this.closeAnimationTimeout);
    this.mainDetailsToggle.classList.add('menu-closing');

    this.closeAnimationTimeout = setTimeout(() => {
      this.mainDetailsToggle.classList.remove('menu-closing');
      super.close();
    }, 200);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

function initNestedHeaderSubmenuHover() {
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  document.querySelectorAll('.header__submenu details').forEach((details) => {
    if (details.dataset.hoverBound) return;
    details.dataset.hoverBound = 'true';

    const summary = details.querySelector('summary');

    details.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      details.setAttribute('open', '');
      summary?.setAttribute('aria-expanded', 'true');
    });

    details.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      details.removeAttribute('open');
      summary?.setAttribute('aria-expanded', 'false');
    });

    summary?.addEventListener('click', (event) => {
      if (isDesktop()) event.preventDefault();
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initNestedHeaderSubmenuHover);
} else {
  initNestedHeaderSubmenuHover();
}
